module.exports = __webpack_public_path__ + "fonts/fa-solid-900.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-solid-900.eot
// module id = 13
// module chunks = 0